import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to = "/dashboard", label = "Back to Dashboard", className = "" }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      data-testid="back-to-dashboard"
      className={`inline-flex items-center gap-2 min-h-11 text-sm text-[#94A3B8] hover:text-[#00F0FF] transition group ${className}`}
    >
      <span className="w-8 h-8 rounded-full border border-[#2A3A5F] flex items-center justify-center group-hover:border-[#00F0FF] group-hover:bg-[#00F0FF]/10 transition">
        <ArrowLeft className="w-4 h-4" />
      </span>
      <span className="uppercase tracking-[0.2em] text-xs">{label}</span>
    </button>
  );
}
